import CustomizedImageInput from "../CustomizedImageInput";
import { Constant, ObservationImages } from "../../constants";
import { TranslateStringValue } from "../../utilities";
import "./style.css";

const SummaryReportCard = (props) => {
    const {
        title,
        schema,
        data,
        error,
        formStep,
    } = props

    const editError = (isError, name) => {
        if (isError) {
            window.dispatchEvent(new Event(Constant.event.closeSummary))
            window.dispatchEvent(new CustomEvent(Constant.event.goToSpecificStep, { detail: { step: formStep, inputName: name } }))
        }
    }

    const getObservationImage = (questionId) => {
        const observationImageEl = []
        const temp = ObservationImages.getImage()
        const observationImages = ObservationImages.getImageOfObservation(questionId)
        observationImages.forEach(image => {
            observationImageEl.push(<div key={image.id} className="w-50 h-100">
                <CustomizedImageInput key={image.id} questionId={questionId} id={image.id} filename={questionId} />
            </div>)
        })
        return observationImageEl
    }

    return <div className="report-card">
        <h2>{title}</h2>
        {schema.map(s => <div key={s.name} className={`w-100 question ${error[s.name] ? 'error' : ''}`} onClick={() => editError(error[s.name], s.name)}>
            {s.label} {TranslateStringValue.translate(s.requis) ? "*" : ""} : {data[s.name]}
            <div className="w-100 d-flex flex-wrap justify-content-between align-items-center">
                {
                    s.label.indexOf("Observation") > -1 || s.label.indexOf("Oservation") > -1 ?
                        getObservationImage(s.name)
                        : null
                }
            </div>
        </div>)}
    </div>
}

export default SummaryReportCard;